import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import chocolate from '../images/Mint-Chocolate-Chip-Ice-Cream.jpg';
import doubleScoop from '../images/Scoops-kinds-ice-cream.jpg';

const PageWrapper = styled.div`
  background: linear-gradient(rgba(255, 255, 255, 0.9), rgba(255, 255, 255, 0.9)),
              url('https://images.unsplash.com/photo-1538489949601-cbabf5b0c105?ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80');
  background-size: cover;
  background-attachment: fixed;
  background-position: center;
  min-height: 100vh;
`;

const MenuContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 7rem 2rem;
  flex: 1;
`;

const Title = styled.h2`
  text-align: center;
  font-size: 2.8rem;
  margin-bottom: 1rem;
  color: #333;
  font-weight: 700;
`;

const Subtitle = styled.p`
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 3rem;
  color: #666;
`;

const MenuGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 2rem;
`;

const MenuItem = styled.div`
  background: rgba(255, 255, 255, 0.95);
  border-radius: 15px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease, box-shadow 0.3s ease;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
`;

const ItemImage = styled.div`
  height: 220px;
  background-size: cover;
  background-position: center;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50%;
    background: linear-gradient(to top, rgba(0,0,0,0.3), transparent);
  }
`;

const ItemContent = styled.div`
  padding: 1.5rem;
  background: white;
`;

const ItemTitle = styled.h3`
  font-size: 1.3rem;
  margin-bottom: 0.5rem;
  color: #333;
  font-weight: 600;
`;

const ItemDescription = styled.p`
  color: #666;
  line-height: 1.5;
  font-size: 0.95rem;
  margin-bottom: 1rem;
`;

const ItemPrice = styled.span`
  color: #ff6b6b;
  font-weight: 600;
  font-size: 1.2rem;
  display: block;
  margin-bottom: 1rem;
`;

const AddToCartButton = styled.button`
  background: #ff6b6b;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  border-radius: 8px;
  font-weight: 600;
  cursor: pointer;
  width: 100%;
  transition: all 0.3s ease;

  &:hover {
    background: #ff5252;
    transform: translateY(-2px);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

const QuantityControl = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1rem;
`;

const QuantityButton = styled.button`
  background: #f0f0f0;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 5px;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s ease;

  &:hover {
    background: #e0e0e0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

const Quantity = styled.span`
  font-size: 1.1rem;
  min-width: 2rem;
  text-align: center;
`;

const CartButton = styled.button`
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  background: #ff6b6b;
  color: white;
  border: none;
  padding: 1rem 2rem;
  border-radius: 50px;
  font-weight: 600;
  cursor: pointer;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 1000;

  &:hover {
    background: #ff5252;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.3);
  }

  &:disabled {
    background: #ccc;
    cursor: not-allowed;
    transform: none;
  }
`;

const CartCount = styled.span`
  background: white;
  color: #ff6b6b;
  padding: 0.2rem 0.6rem;
  border-radius: 50%;
  font-size: 0.9rem;
  font-weight: bold;
`;

const menuItems = [
  {
    id: 1,
    name: 'Vanilla Bean',
    description: 'Classic vanilla ice cream made with real Madagascar vanilla beans',
    price: '$4.50',
    image: 'https://images.unsplash.com/photo-1570197571499-166b36435e9f?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
  },
  {
    id: 2,
    name: 'Chocolate Fudge',
    description: 'Rich chocolate ice cream with swirls of homemade fudge',
    price: '$4.75',
    image: 'https://images.unsplash.com/photo-1563805042-7684c019e1cb?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
  },
  {
    id: 3,
    name: 'Strawberry Fields',
    description: 'Fresh strawberry ice cream with real fruit pieces',
    price: '$4.75',
    image: 'https://images.unsplash.com/photo-1557142046-c704a3adf364?ixlib=rb-1.2.1&auto=format&fit=crop&w=500&q=60'
  },
  {
    id: 4,
    name: 'Mint Chocolate Chip',
    description: 'Cool mint ice cream studded with dark chocolate chips',
    price: '$4.75',
    image: chocolate
  },
  {
    id: 5,
    name: 'Sea Salt Caramel',
    description: 'Caramel ice cream with a touch of sea salt',
    price: '$5.00',
    image: 'https://images.unsplash.com/photo-1579954115545-a95591f28bfc?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80'
  },
  {
    id: 6,
    name: 'Cookie Dough',
    description: 'Vanilla ice cream loaded with chunks of cookie dough',
    price: '$5.00',
    image: 'https://images.unsplash.com/photo-1558138838-76294be30005?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80'
  },
  {
    id: 7,
    name: "Fresh Strawberry",
    description: "Creamy strawberry ice cream made with fresh local strawberries.",
    price: "$4.75",
    image: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
  },
  {
    id: 8,
    name: "Mint Chocolate Chip",
    description: "Cool mint ice cream studded with premium dark chocolate chips.",
    price: "$4.75",
    image: "https://images.unsplash.com/photo-1580915411954-282cb1b0d780?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1470&q=80"
  },
  {
    id: 9,
    name: "Double Scoop Cone",
    description: "Made with slow-churned, velvety ice cream from locally sourced milk.",
    price: "$6.99",
    image: doubleScoop
  },
];

function Menu() {
  const [quantities, setQuantities] = useState({});
  const [cart, setCart] = useState([]);
  const navigate = useNavigate();

  const updateQuantity = (id, delta) => {
    setQuantities(prev => ({
      ...prev,
      [id]: Math.max(0, (prev[id] || 0) + delta)
    }));
  };

  const addToCart = (item) => {
    const quantity = quantities[item.id] || 0;
    if (quantity > 0) {
      const cartItem = {
        id: item.id,
        name: item.name,
        quantity: quantity,
        price: parseFloat(item.price.replace('$', '')),
        totalPrice: quantity * parseFloat(item.price.replace('$', ''))
      };

      setCart(prevCart => {
        // Check if item already exists in cart
        const existingItemIndex = prevCart.findIndex(i => i.id === item.id);
        if (existingItemIndex >= 0) {
          // Update existing item
          const newCart = [...prevCart];
          newCart[existingItemIndex] = cartItem;
          return newCart;
        } else {
          // Add new item
          return [...prevCart, cartItem];
        }
      });

      // Reset quantity for this item
      setQuantities(prev => ({ ...prev, [item.id]: 0 }));
      alert(`Added ${quantity} ${item.name}(s) to cart!`);
    }
  };

  const proceedToCheckout = () => {
    if (cart.length > 0) {
      navigate('/order', { 
        state: { 
          orderDetails: {
            items: cart
          }
        } 
      });
    }
  };

  const totalItemsInCart = cart.reduce((sum, item) => sum + item.quantity, 0);

  return (
    <PageWrapper>
      <MenuContainer>
        <Title>Our Menu</Title>
        <Subtitle>Discover our delicious selection of handcrafted ice creams</Subtitle>
        <MenuGrid>
          {menuItems.map((item) => (
            <MenuItem key={item.id}>
              <ItemImage style={{ backgroundImage: `url(${item.image})` }} />
              <ItemContent>
                <ItemTitle>{item.name}</ItemTitle>
                <ItemDescription>{item.description}</ItemDescription>
                <ItemPrice>{item.price}</ItemPrice>
                <QuantityControl>
                  <QuantityButton 
                    onClick={() => updateQuantity(item.id, -1)}
                    disabled={!quantities[item.id]}
                  >
                    -
                  </QuantityButton>
                  <Quantity>{quantities[item.id] || 0}</Quantity>
                  <QuantityButton 
                    onClick={() => updateQuantity(item.id, 1)}
                  >
                    +
                  </QuantityButton>
                </QuantityControl>
                <AddToCartButton 
                  onClick={() => addToCart(item)}
                  disabled={!quantities[item.id]}
                >
                  Add to Cart
                </AddToCartButton>
              </ItemContent>
            </MenuItem>
          ))}
        </MenuGrid>
      </MenuContainer>
      {totalItemsInCart > 0 && (
        <CartButton onClick={proceedToCheckout}>
          Proceed to Checkout
          <CartCount>{totalItemsInCart}</CartCount>
        </CartButton>
      )}
    </PageWrapper>
  );
}

export default Menu;
